/* eslint-disable max-len */
import React from 'react';
import { Route } from 'react-router-dom';
import Error from '../components/Alert';
import ErrorBoundary from '../components/ErrorBoundary';
import Footer from '../components/Footer/FooterHtml';
import Header from '../components/HeaderPubblica/HeaderHtml';
import Spinner from '../components/Spinner';

import { ContextProvider } from '../utils/Context';

function PublicLayout({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <ContextProvider>
          <Header />
          <Error />
          <ErrorBoundary>
            <div id="main-content" role="main" className="w-100 mb-5">
              <Component {...matchProps} />
            </div>
          </ErrorBoundary>
          <Footer />
          <Spinner />
        </ContextProvider>
      )}
    />
  );
}

export default PublicLayout;
